<template>
  <div>
    <div v-if="type == 'popDialog' && showPopDialog && storePopDialogConfig" class="new--module gift-dialog">
      <img class="card" :alt="storePopDialogConfig.title" :src="storePopDialogConfig.dialogConfig.pic" @click="clickPopDialog" />
      <i class="icon-close" @click="closePopDialog"></i>
    </div>
    <!-- 挂件 -->
    <div
      v-if="type == 'pendant' && showPopDialog && storePopDialogConfig"
      ref="floatPendant"
      class="new--moudle welfare"
      :style="{ top: floatPendantTop, 'z-index': 109 }"
    >
      <img :src="storePopDialogConfig.dialogConfig.pic" alt="" @click="clickPopDialog" />
    </div>
  </div>
</template>

<script>
import { getStorePopDialogConfig } from "../../api/serviceZone.js"
const POP_DIALOG_CACHE_KEY = "wechat_store_pop_dialog_history"
import localstorage from "../../utils/localStorage.js"
import * as reportDict from "../../constants/report-dictonary"
import { addGetParam } from "../../utils/url"
import { queryWhiteListByRecommendModal } from "../../api/task"
import { mapGetters, mapActions } from "vuex"
import Raven from "raven-js"

/**
 * 检测用户是否在白名单列表页
 * @param context
 * @returns {Promise}
 */
function checkWhiteList(context) {
  return new Promise((resolve, reject) => {
    queryWhiteListByRecommendModal({
      sandbox: context.sandbox,
      offerId: "1450000186",
      loginState: context.loginState,
      recomm_model: context.storePopDialogConfig.recommendModal
    })
      .then(res => {
        if (res.ret === 0 && res.data.white == "1") {
          resolve()
        } else {
          reject()
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

export default {
  props: {
    currentItemKey: {
      type: String
    },
    loginState: {
      type: Object
    },
    type: {
      type: String,
      default: "popDialog"
    }
  },

  data() {
    return {
      showPopDialog: false,
      storePopDialogConfig: null,
      floatPendantTop: "3.9rem"
    }
  },

  computed: {
    ...mapGetters(["pf", "sandbox", "userAgent", "iosRechargeEnable", "offerId"])
  },

  mounted() {
    this.initPop()
  },

  methods: {
    ...mapActions(["reportUserAction", "queryWhiteList", "checkIosWhiteListRecharge"]),
    /**
     * 根据外部传入的key, 获取排脸的配置文件
     * 判断是否可以展示排脸图
     * 如果展示了，则设置展示排脸弹窗
     */
    initPop() {
      getStorePopDialogConfig(this.currentItemKey, this.pf)
        .then(async storePopDialogConfig => {
          await this.checkIosWhiteListRecharge(this.offerId)
          // 配置了ios_whitlist 白名单校验，则白名单用户才通过
          if (
            !storePopDialogConfig?.enable_ios_whitlist ||
            !this.userAgent.iOS ||
            (storePopDialogConfig?.enable_ios_whitlist && this.iosRechargeEnable[`${this.offerId}_${this.loginState.openid}`])
          ) {
            if (storePopDialogConfig) {
              this.storePopDialogConfig = storePopDialogConfig
              this.checkIfUserCanShowPop()
                .then(() => {
                  this.showPopDialog = true

                  // 如果为挂件且可展示，则初始化悬浮能力
                  if (this.type == "pendant") this.initFloatPendant()

                  let popDialogCache = this.getPopDialogCache()
                  // 每弹出一次，则记录拍脸次数+1
                  popDialogCache.popTimes = popDialogCache.popTimes + 1
                  // 更新cache
                  localstorage.set(this.getLocalStorageKey(), JSON.stringify(popDialogCache))

                  this.reportUserAction({
                    iformat: this.type == "pendant" ? reportDict.PAGE_VIEW.PENDANT_SHOW : reportDict.PAGE_VIEW.SERVICE_ZONE_POP_SHOW
                  })
                })
                .catch(err => {
                  this.showPopDialog = false
                  if (err) {
                    Raven.captureException(new Error("unknown pop type"), {
                      tags: { type: "unknown pop type" },
                      extra: {
                        err
                      }
                    })
                  }
                })
            } else {
              // console.log("缺少拍脸配置或活动失效")
            }
          }
        })
        .catch(err => {
          //   console.log("获取拍脸图配置失败")
          if (err) {
            Raven.captureException(new Error("unknown pop config"), {
              tags: { type: "unknown pop config" },
              extra: {
                err
              }
            })
          }
        })
    },

    // 获取拍脸弹窗缓存
    getPopDialogCache() {
      let popDialogCache = localstorage.get(this.getLocalStorageKey(), true) || {}

      if (popDialogCache && popDialogCache.popTimes) {
        return popDialogCache
      } else {
        return {
          activityNum: this.storePopDialogConfig.dialogConfig.activityNum,
          popTimes: 0,
          invalid: false
        }
      }
    },

    /**
     * 根据配置文件判断当前配置的拍脸图的跳转情况
     * 如果是自定义，则调用外部传入的customClickPop方法
     */
    clickPopDialog() {
      // let clickPopTime = +new Date()

      // 跳转外部链接
      if (this.storePopDialogConfig.directScene === "jumpOuter") {
        if (!this.storePopDialogConfig.afterJumpIsShow) this.setPopDialogInvalid()

        location.href = addGetParam(
          {
            pf: this.pf
          },
          this.storePopDialogConfig.jumpOuterLink
        )
      }

      // 跳转内部的hash业务
      if (this.storePopDialogConfig.directScene === "jumpInner") {
        if (!this.storePopDialogConfig.afterJumpIsShow) this.setPopDialogInvalid()

        this.$router.push({
          path: this.storePopDialogConfig.jumpInnerService
        })
      }

      if (this.storePopDialogConfig.directScene === "custom") {
        this.$emit("customClickPop", this.storePopDialogConfig)
      }

      // 首页挂件或拍脸图，记录打开首页到用户点击的时间
      if (this.storePopDialogConfig.biz_key.indexOf("index") > -1) {
        this.reportUserAction({
          iformat: reportDict.SCAN.PENDANT
          // resultInfo: `time=${parseInt((clickPopTime - window.INDEX_RENDER_TIME) / 1000)}&page=pendant`
        })
      }

      this.reportUserAction({
        iformat: this.type == "pendant" ? reportDict.CLICK.PENDANT : reportDict.CLICK.POP_DIALOG
      })
    },

    /**
     * 关闭拍脸弹窗
     * 此方法可被外部调用，关闭弹窗 this.refs.xxx.closePopDialog
     * invalid 为 true代表弹窗配置已无效，不需要重复弹窗
     */
    closePopDialog() {
      this.showPopDialog = false
    },

    /**
     * 设置弹窗内容无效，下次不出现， localstorage 内的 invalid 标明这个含义
     *
     */
    setPopDialogInvalid() {
      let popDialogCache = this.getPopDialogCache()

      // 设置弹窗无效，下次不弹出来了
      popDialogCache.invalid = true

      // 更新cache
      localstorage.set(this.getLocalStorageKey(), JSON.stringify(popDialogCache))

      this.showPopDialog = false
    },

    /**
     * 判断当前的pop弹窗是否用户可见
     * 用户可见则resolve
     * 用户不可见则reject
     */
    checkIfUserCanShowPop() {
      return new Promise((resolve, reject) => {
        if (
          this.storePopDialogConfig &&
          this.storePopDialogConfig.dialogConfig &&
          this.storePopDialogConfig.dialogConfig.pic &&
          this.storePopDialogConfig.dialogConfig.totalTimes
        ) {
          let popDialogCache = this.getPopDialogCache()

          // 用户的拍脸次数小于配置的拍脸次数并且用户重来没
          if (
            popDialogCache.popTimes < this.storePopDialogConfig.dialogConfig.totalTimes &&
            !popDialogCache.invalid &&
            this.shouldDisplayPlatform()
          ) {
            if (this.storePopDialogConfig.showScene === "all") {
              resolve()
            } else if (this.storePopDialogConfig.showScene === "filterByRecommend") {
              checkWhiteList(this)
                .then(() => {
                  resolve()
                })
                .catch(() => {
                  reject()
                })
            } else if (
              this.storePopDialogConfig.showScene === "filterByWhiteList" &&
              this.storePopDialogConfig.whiteListActivityId &&
              this.storePopDialogConfig.whiteListOfferId
            ) {
              this.queryWhiteList({
                activity_id: this.storePopDialogConfig.whiteListActivityId,
                offerId: this.storePopDialogConfig.whiteListOfferId
              })
                .then(res => {
                  if (res.info && res.info.white_list_value) {
                    if (parseInt(res.info.white_list_value) === 1 || res.info.white_list_value === "received") {
                      resolve()
                    } else {
                      reject()
                    }
                  } else {
                    reject()
                  }
                })
                .catch(e => {
                  reject(e)
                  Raven.captureException(new Error("popDialog-check-whiteList-error"), {
                    tags: { type: "popDialog-check-whiteList-error" },
                    extra: {
                      activityId: this.storePopDialogConfig.whiteListActivityId,
                      e
                    }
                  })
                })
            } else {
              // 其他未知类型（可扩展）
              reject({
                msg: "未知配置类型"
              })
            }
          } else {
            reject()
          }
        }
      })
    },

    /**
     * 获取当前的缓存key值
     * @returns {string}
     */
    getLocalStorageKey() {
      return `${POP_DIALOG_CACHE_KEY}_${this.currentItemKey}_${this.storePopDialogConfig.itemId}`
    },

    /**
     * 设置平台是否展示
     * @returns {boolean}
     */
    shouldDisplayPlatform() {
      const ua = this.userAgent

      let platform = ""

      if (ua.iOS) {
        platform = "ios"
      } else {
        platform = "android"
      }

      if (ua.QQ) {
        platform += "_qq"
      } else if (ua.weixin) {
        platform += "_wx"
      } else {
        platform += "_other"
      }

      if (this.storePopDialogConfig.platform) {
        return this.storePopDialogConfig.platform.indexOf(platform) !== -1
      }

      return false
    },

    /**
     * 悬浮挂件初始化，可上下拖动
     */
    initFloatPendant() {
      this.$nextTick(() => {
        let floatPendant = this.$refs.floatPendant
        if (floatPendant) {
          floatPendant.addEventListener("touchstart", () => {
            floatPendant.style.transition = "none"
          })
          floatPendant.addEventListener("touchmove", e => {
            if (e.targetTouches.length === 1) {
              let touch = e.targetTouches[0]
              if (touch.clientY - 30 > 0 && touch.clientY < document.body.clientHeight - 70) {
                this.floatPendantTop = touch.clientY - 30 + "px"
              }
            }
            e.preventDefault()
          })
          floatPendant.addEventListener("touchend", () => {
            floatPendant.style.transition = "all 0.3s"
          })
        }
      })
    }
  }
}
</script>
